module.exports = __webpack_public_path__ + "media/MidwestStyleHouse@1x.9d462614.svg";